<ngx-skeleton-loader
  [count]="count"
  [appearance]="appearance"
  [theme]="theme"
></ngx-skeleton-loader>
